'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QueryNodeWalker = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ValueSetRegistry = require('../ValueSetRegistry');

var _ValueSetRegistry2 = _interopRequireDefault(_ValueSetRegistry);

var _QueryNodeWalkerContext = require('./QueryNodeWalkerContext');

var _QueryNodeWalkerContext2 = _interopRequireDefault(_QueryNodeWalkerContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QueryNodeWalker = exports.QueryNodeWalker = function () {
    function QueryNodeWalker() {
        (0, _classCallCheck3.default)(this, QueryNodeWalker);

        this.context = null;
        this.defaultSkipData = false;
        this.defaultSkipChildren = false;
    }

    (0, _createClass3.default)(QueryNodeWalker, [{
        key: 'dispatchVisit',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(visitor) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return visitor.visit(this.context);

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function dispatchVisit(_x) {
                return _ref.apply(this, arguments);
            }

            return dispatchVisit;
        }()
    }, {
        key: 'walk',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(queryNode, visitor, appContext) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.context = new _QueryNodeWalkerContext2.default();
                                this.context.appContext = appContext;
                                this.context.startingNode = queryNode;
                                _context2.next = 5;
                                return this.walkNode(queryNode, visitor);

                            case 5:
                                this.context = null;

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function walk(_x2, _x3, _x4) {
                return _ref2.apply(this, arguments);
            }

            return walk;
        }()
    }, {
        key: 'walkNode',
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(queryNode, visitor) {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.context.skipData = this.defaultSkipData;
                                this.context.skipChildren = this.defaultSkipChildren;
                                this.context.pushNode(queryNode);
                                this.context.pushVisitType('node');
                                _context3.next = 6;
                                return this.dispatchVisit(visitor);

                            case 6:
                                _context3.next = 8;
                                return this.walkData(queryNode.data, visitor);

                            case 8:
                                _context3.next = 10;
                                return this.walkChildren(queryNode.children, visitor, queryNode);

                            case 10:
                                this.context.popVisitType();
                                this.context.popNode();

                            case 12:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function walkNode(_x5, _x6) {
                return _ref3.apply(this, arguments);
            }

            return walkNode;
        }()
    }, {
        key: 'walkData',
        value: function () {
            var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(data, visitor) {
                var dataKey, dataValue, reconstitutedValueSet;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!this.context.skipData) {
                                    _context4.next = 2;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 2:
                                this.context.pushPath('data');
                                _context4.t0 = _regenerator2.default.keys(data);

                            case 4:
                                if ((_context4.t1 = _context4.t0()).done) {
                                    _context4.next = 25;
                                    break;
                                }

                                dataKey = _context4.t1.value;

                                if (data.hasOwnProperty(dataKey)) {
                                    _context4.next = 8;
                                    break;
                                }

                                return _context4.abrupt('continue', 4);

                            case 8:
                                dataValue = data[dataKey];

                                this.context.currentDataKey = dataKey;
                                this.context.currentDataValue = dataValue;
                                this.context.pushPath(dataKey);

                                if (!(dataValue && dataValue._isValueSet)) {
                                    _context4.next = 18;
                                    break;
                                }

                                reconstitutedValueSet = _ValueSetRegistry2.default.reconstituteDeserializedJson(dataValue);
                                _context4.next = 16;
                                return this.walkValueSet(reconstitutedValueSet, visitor);

                            case 16:
                                _context4.next = 20;
                                break;

                            case 18:
                                _context4.next = 20;
                                return this.walkDataValue(visitor);

                            case 20:
                                this.context.popPath();
                                this.context.currentDataKey = null;
                                this.context.currentDataValue = null;
                                _context4.next = 4;
                                break;

                            case 25:
                                this.context.popPath();

                            case 26:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function walkData(_x7, _x8) {
                return _ref4.apply(this, arguments);
            }

            return walkData;
        }()
    }, {
        key: 'walkValueSet',
        value: function () {
            var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(valueSet, visitor) {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                this.context.currentValueSet = valueSet;
                                this.context.pushVisitType('valueSet');
                                _context5.next = 4;
                                return this.dispatchVisit(visitor);

                            case 4:
                                this.context.popVisitType();
                                this.context.currentValueSet = null;

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function walkValueSet(_x9, _x10) {
                return _ref5.apply(this, arguments);
            }

            return walkValueSet;
        }()
    }, {
        key: 'walkDataValue',
        value: function () {
            var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(visitor) {
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                this.context.pushVisitType('data');
                                _context6.next = 3;
                                return this.dispatchVisit(visitor);

                            case 3:
                                this.context.popVisitType();

                            case 4:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function walkDataValue(_x11) {
                return _ref6.apply(this, arguments);
            }

            return walkDataValue;
        }()
    }, {
        key: 'walkChildren',
        value: function () {
            var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(children, visitor) {
                var index, child;
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (!this.context.skipChildren) {
                                    _context7.next = 2;
                                    break;
                                }

                                return _context7.abrupt('return');

                            case 2:
                                this.context.pushPath('children');
                                index = 0;

                            case 4:
                                if (!(index < children.length)) {
                                    _context7.next = 13;
                                    break;
                                }

                                child = children[index];

                                this.context.pushPath(index);
                                _context7.next = 9;
                                return this.walkNode(child, visitor);

                            case 9:
                                this.context.popPath();

                            case 10:
                                index += 1;
                                _context7.next = 4;
                                break;

                            case 13:
                                this.context.popPath();

                            case 14:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function walkChildren(_x12, _x13) {
                return _ref7.apply(this, arguments);
            }

            return walkChildren;
        }()
    }]);
    return QueryNodeWalker;
}();

exports.default = QueryNodeWalker;